import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { requiredValidation } from 'validators';
import { TextField, Typography } from 'seagull';
import { VariableInlineRenderer } from '~/components/AgreementStudioPage/TemplateVariables/VariableInlineRenderer/VariableInlineRenderer';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import { getServiceName } from './service.utils';
export default function ServiceNameCell(param) {
    let { service, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const form = useForm({
        mode: 'all',
        defaultValues: {
            name: service.name
        }
    });
    const onClick = ()=>{
        onOpenModal({
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: 'Service name',
                    testId: "edit-service-name-modal-".concat(index),
                    onSubmit: (defaultBehavior)=>{
                        form.handleSubmit(defaultBehavior)();
                    },
                    content: /*#__PURE__*/ _jsx(FormProvider, _object_spread_props(_object_spread({}, form), {
                        children: /*#__PURE__*/ _jsx(Controller, {
                            control: form.control,
                            name: "name",
                            rules: requiredValidation(true),
                            render: (renderProps)=>/*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                                    collapseHelperText: false
                                }, connectControllerToTextField(renderProps)), {
                                    label: "Service name",
                                    testId: "edit-service-name-".concat(index),
                                    value: getServiceName({
                                        serviceId: service.id,
                                        draft
                                    }),
                                    onChange: (e)=>{
                                        form.setValue('name', e.target.value);
                                        setDraft(draft.setService(service.id, (s)=>_object_spread_props(_object_spread({}, s), {
                                                name: e.target.value
                                            })));
                                    }
                                }))
                        })
                    }))
                };
            }
        });
    };
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-service-name-cell-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: "service-name-".concat(index),
            ellipsis: true,
            children: /*#__PURE__*/ _jsx(VariableInlineRenderer, {
                text: service.name,
                mode: "text"
            })
        })
    });
}
